// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { shallowRef } from 'vue';
import { mapState, mapActions } from 'vuex';
import { PHASE } from './constants';
import { readApi } from './read';
import { writeExecuteApi } from './writeExecute';
import { writeApi } from './write';
import { exitApi } from './exit';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import requirement002 from '../../../../components/vue/individualWorkSupport/Requirement002.vue';
import requirement012 from '../../../../components/vue/individualWorkSupport/Requirement012.vue';

export default {
  name: 'requirement038',
  data() {
    return {
      modalSize: 'md',
      phase: PHASE.START,
      isLoading: false,
      isInitialized: false,
      isHidden: false,
      displayInfo: '',
      readData: '',
      currentWizard: '',
      systemId: '',
      prevPhase: '',
      fixedPinNumber: '',
      pinNumber: '',
      validatePinNumber: undefined,
      // ダイアログフラグ
      modal_requirement_038: false
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  components: {
    'requirement002': requirement002,
    'requirement012': requirement012
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),

    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.CONNECTION_FAILED:
        case PHASE.ERROR_PIN_NUMBER:
        case PHASE.ODOMETER_FAILED:
          return 'danger';
        case PHASE.WRITE_SUCCESS:
          return 'success';
        case PHASE.EXECUTION:
        case PHASE.WRITE_NEW_METER:
        case PHASE.WRITE_OLD_METER:
        case PHASE.DISPLAY_WRITING:
        case PHASE.DISPLAY_STOP:
        case PHASE.WARNING:
        case PHASE.START:
        case PHASE.DISPLAY_PIN_NUMBER:
        case PHASE.INPUT_PIN_NUMBER:
        default:
          return 'secondary';
      }
    },
  },
  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /**
     *
     * @param {*} event WS.2からの返り値
     */
    requirementReturn(event) {
      // WS.2で正常終了した場合、WS.38モーダルを起動
      if (event) {
        this.isInitialized = false;
        this.systemId = individualDiagnose.getCurrentSystemId(this);
        this.closeComponentModal();
        this.modal_requirement_038 = true;
      } else {
        this.closeWizard();
      }
    },

    // コンポーネントのモーダルを閉じる
    closeComponentModal() {
      if (this.$refs.currentWizardComponent && typeof this.$refs.currentWizardComponent.closeModal === 'function') {
        this.$refs.currentWizardComponent.closeModal();
      }
    },

    /** 初期化処理 */
    init() {
      // ECUキーの取得
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      // 現在のウィザードを設定
      this.currentWizard = shallowRef(requirement002);
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_038 = false;
    },

    //----- htmlイベントメソッド ------------------------------------------------------//

    /**
     * 旧メータ取り付け
     */
    async oldMeter() {
      // 旧メータ取り付け画面表示
      this.isHidden = true;
      this.displayInfo = this.i18nWsKey + '.label_attach_old_meter';
    },

    /**
     * 新メータ書込み
     */
    async writeNewMeter() {
      // 新メータ書込み画面へ遷移
      this.phase = PHASE.WRITE_NEW_METER;
    },

    /**
     * 旧メータ書込み
     */
    async writeOldMeter() {
      // 旧メータ書込み画面へ遷移
      this.phase = PHASE.WRITE_OLD_METER;
    },

    /**
     * 書込み中表示
     */
    async displayWriting() {
      this.prevPhase = this.phase;
      // 書込み中表示画面へ遷移
      this.displayInfo = this.i18nWsKey + '.label_please_wait';
      this.phase = PHASE.DISPLAY_WRITING;
      // データ書込み
      this.writeExecuteApi();
    },

    /**
     * 警告表示
     */
    async displayWarning() {
      // データ読出し
      this.readApi();
    },

    /**
     * 処理中止表示
     */
    async displayStop() {
      // 処理中止表示画面へ遷移
      this.phase = PHASE.DISPLAY_STOP;
    },

    /** 警告表示でOKを押された時の処理 */
    displayPinNumber() {
      this.modalSize = 'md';
      this.phase = PHASE.DISPLAY_PIN_NUMBER;
    },

    /** 暗証番号表示でOKを押された時の処理 */
    inputPinNumber() {
      this.modalSize = 'lg';
      this.phase = PHASE.INPUT_PIN_NUMBER;
      this.pinNumber = this.fixedPinNumber;
      this.validatePinNumber = undefined;
    },

    /** 暗証番号入力でOKを押された時の処理 */
    validateInputPinNumber() {
      if (this.pinNumber === '') {
        this.fixedPinNumber = this.pinNumber;
        this.displayPinNumber();
        return;
      }

      this.validatePinNumber = undefined;
      if (this.pinNumber.length > 16) {
        this.validatePinNumber = { invalid: true, msg: this.$t(`message.alert_validate_max_length`, ['16']) };
        return;
      }
      if (!/^(\d+)$/i.test(this.pinNumber)) {
        this.validatePinNumber = { invalid: true, msg: this.$t(`message.alert_validate_invalid_pattern`) };
        return;
      }

      this.fixedPinNumber = this.pinNumber;
      this.displayPinNumber();
    },

    /** オドメータ書込み失敗表示でOKを押された時の処理 */
    transitionPrevPhase() {
      this.phase = this.prevPhase;
    },

    //----- フェーズごとの定義 --------------------------------------------------------//

    // フェーズに対応するタイプを設定
    phaseForType(phase) {
      let forType = '';
      switch (phase) {
        case PHASE.START:
          forType = 'read_write';
          break;
        case PHASE.WRITE_SUCCESS:
          forType = 'read';
          break;
        default:
          break;
      }
      return forType;
    },

    // タイプに対応する結果
    typeForResponse(result) {
      switch (this.phase) {
        case PHASE.START:
          // 正常終了：取得できたオドメーター値を保持、メータ交換確認画面に遷移
          this.readData = result.user_data.odometer;
          this.displayInfo = this.i18nWsKey + '.label_complete_read_odometer';
          this.phase = PHASE.EXECUTION;
          break;
        case PHASE.WRITE_SUCCESS:
          switch (result.user_data.result) {
            case 'ok':
              // WS12機能を実行
              this.currentWizard = shallowRef(requirement012);
              this.modal_requirement_038 = false;
              break;
            case 'ng':
            default:
              // モード変更確認画面に遷移
              this.phase = PHASE.WARNING;
              break;
          }
          break;
        default:
          break;
      }
    },

    //----- バックエンドAPI実行メソッド -----------------------------------------------//

    /**
     * 読み出しAPI関数
     */
    async readApi() {
      await readApi(this);
    },

    /**
     * 書込み(取得データの書き込み)API関数
     */
    async writeExecuteApi() {
      await writeExecuteApi(this);
    },

    /**
     * 書込みAPI関数
     */
    async writeApi() {
      await writeApi(this);
    },

    /**
     * 終了処理メソッド
     */
    async exitApi() {
      await exitApi(this);
    },

    //----- 異常コールバックメソッド -----------------------------------------------//

    /**
     * API 通信エラー発生のコールバック用
     */
    showUnexpectedError() {
      //エラー遷移あり：共通エラー表示
      this.phase = PHASE.CONNECTION_FAILED;
    },

    /**
     * API 通信共通バリデーションエラー発生のコールバック
     * @param {object} result バリデーション結果
    */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },
  },
  async mounted() {
    this.init();
  },
};
